<div class="c-multitab">
  <div class="c-multitab-header">
    <img
      [src]="logoImage"
      class="slotcom-logo" />
  </div>
  <div class="c-multitab-container">
    <img
      [src]="monkeyImage"
      class="slotcom-monkey" />
    <div class="multitab-content">
      <div class="text-title">
        {{ multitabCopies.title | translate | uppercase }}
      </div>
      <div class="text-description">
        {{ multitabCopies.description | translate }}
      </div>
      <slotcom-button
        class="c-button--pink"
        (safeClick)="playHere()"
        audioType="functionality">
        <span>{{ multitabCopies.buttonLabel | translate | uppercase }}</span>
      </slotcom-button>
    </div>
  </div>
</div>
